import { NavLink } from 'react-router-dom';
import { useRole } from '@auth/RoleContext';
import type { ShippingRole } from '@/types/index';

/**
 * Nav — left sidebar. Each link declares the App Roles that may see it; links the
 * current user cannot reach are not rendered (architecture §4: Warehouse sees the
 * board + build action; Admin additionally sees config + reports).
 *
 * This is presentational gating only — the authoritative gate is <RequireRole>
 * on the routes (and, in production, the server-side requireRole choke-point).
 * Hiding the link is a courtesy so staff are not shown a control they cannot use.
 */
interface NavItem {
  to: string;
  label: string;
  anyOf: ShippingRole[];
}

const ITEMS: NavItem[] = [
  { to: '/board', label: 'Warehouse Board', anyOf: ['Warehouse', 'Admin'] },
  { to: '/admin/config', label: 'Admin · Config', anyOf: ['Admin'] },
  { to: '/admin/reports', label: 'Admin · Reports', anyOf: ['Admin'] },
];

export function Nav() {
  const { hasRole } = useRole();
  const visible = ITEMS.filter((i) => hasRole(...i.anyOf));

  return (
    <nav
      style={{
        width: 240,
        flex: '0 0 240px',
        borderRight: '1px solid #E2DDCF',
        background: '#FBFAF6',
        padding: '14px 10px',
      }}
    >
      <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {visible.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              style={({ isActive }) => ({
                display: 'block',
                padding: '8px 12px',
                borderRadius: 6,
                fontSize: 14,
                textDecoration: 'none',
                color: isActive ? '#0A1220' : '#42536B',
                background: isActive ? '#EDE9DC' : 'transparent',
                fontWeight: isActive ? 600 : 500,
              })}
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
